import { useTranslation } from 'react-i18next';
import { AiEnhanceDialog } from './AiEnhanceDialog';
import {
  CorrectStep,
  DownloadStep,
  formatBytes,
  LoadStep,
  StepNav,
  StraightenStep,
} from './ImagesSteps';
import { Stepper } from './Stepper';
import { useImagesFlow } from './use-images-flow';

/**
 * «Immagini» (#387, decision 98; boards approved in decision 99): load or take a photo, straighten
 * it, correct it, download it. Everything runs in the browser through the image engine; only
 * «Migliora con IA» sends the image out, after its notice, and its result is shown beside the
 * original, never in its place (D19).
 */
export function ImagesPage() {
  const { t } = useTranslation('tools');
  const flow = useImagesFlow();
  const { step, session } = flow;
  const fileInfo = session.image
    ? t('images.load.fileInfo', {
        name: session.image.name,
        size: formatBytes(session.image.bytes),
      })
    : '';

  return (
    <div className="space-y-6">
      <div>
        <h2 className="screen-title">{t('images.title')}</h2>
        <p className="screen-summary">{t('images.summary')}</p>
      </div>

      <section className="space-y-5 rounded-xl border border-border bg-card p-4 sm:p-5">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Stepper active={step} />
          {fileInfo && <span className="text-sm text-muted-foreground">{fileInfo}</span>}
        </div>

        {step === 'load' && <LoadStep flow={flow} />}
        {step === 'straighten' && <StraightenStep flow={flow} />}
        {step === 'correct' && <CorrectStep flow={flow} />}
        {step === 'download' && <DownloadStep flow={flow} />}
        {step !== 'load' && <StepNav flow={flow} />}
      </section>

      <AiEnhanceDialog
        open={flow.ai.ai.status === 'confirming'}
        onCancel={() => flow.ai.setAi({ status: 'idle' })}
        onSend={() => void flow.sendToAi()}
      />
    </div>
  );
}
